import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const workItemRoute: InvariantJiraRoute = {
	name: 'work-item',
	exact: true,
	path: '/jira/browse/:issueKey(\\w+-\\d+)(.*)?',
};
